import { render, staticRenderFns } from "./stafftc.vue?vue&type=template&id=578a1623&scoped=true&"
import script from "./stafftc.vue?vue&type=script&lang=js&"
export * from "./stafftc.vue?vue&type=script&lang=js&"
import style0 from "./stafftc.vue?vue&type=style&index=0&id=578a1623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a1623",
  null
  
)

export default component.exports